/**
 * 애플리케이션 전역 상수
 */

// 로케일 및 문화 설정
export const CULTURE = "ko-KR";

// 재고구분 (MenuJ2 - code/name)
const STK_TYPE = {
  "C": "원재료",
  "G": "상품",
  "P": "제품",
  "J": "재공품",
  "S": "Scrap",
  "T": "T/E",
};

export const STK_TYPE_LIST_MENU = Object.entries(STK_TYPE).map(([code, name]) => ({code, name}));
export const DEFAULT_STK_TYPE_MENU = Object.keys(STK_TYPE);

// 조회기준 (MenuJ2)
export const VIEW_OPTION_OPTIONS = [
  { value: "deft", label: "물류기준" },
  { value: "noww", label: "가용재고" },
  { value: "ship", label: "회계기준" },
];

// 소유 구분 (MenuJ2, MenuJ3, MenuJ4 - SelectInput)
export const IM_CLS_OPTIONS = [
  { value: "1", label: "자사" },
  { value: "2", label: "임가공" },
  { value: "3", label: "보관품" },
];

// 매입유형 (MenuJ1)
export const IN_TYPE_OPTIONS = [
  { value: "C", label: "매입" },
  { value: "D", label: "B/L" },
  { value: "E", label: "매입반품" },
  { value: "O", label: "매입할인" },
  { value: "Z", label: "금액조정" },
];

// 출고유형 (MenuJ4)
export const OUT_TYPE_OPTIONS = [
  { value: "S", label: "판매" },
  { value: "Q", label: "송품" },
  { value: "P", label: "생산투입" },
  { value: "M", label: "이동" },
  { value: "B", label: "보관" },
  { value: "G", label: "재고조정" },
  { value: "H", label: "품번해체" },
  { value: "F", label: "보관전환" },
  { value: "J", label: "자가소모" },
];

// 매출유형 (MenuJ5)
export const SHIP_TYPE_OPTIONS = [
  { value: "S", label: "판매" },
  { value: "R", label: "반품" },
  { value: "B", label: "보관" },
  { value: "O", label: "기타" },
  { value: "A", label: "금액조정" },
  { value: "I", label: "임가공정산" },
  { value: "F", label: "보관료정산" },
  { value: "H", label: "운송비정산" },
];

// 수금종류 (MenuJ7)
export const COLLECT_KIND_OPTIONS = [
  { value: "1", label: "현금" },
  { value: "2", label: "예금" },
  { value: "3", label: "어음" },
  { value: "4", label: "상계" },
  { value: "5", label: "기타" },
];

// 숫자 범위 제한값
export const NUMBER_LIMITS = {
  THICKNESS: {
    MIN: 0,
    MAX: 100,
    MAX_EXCLUSIVE: 100, // 경고 메시지용
  },
  WIDTH: {
    MIN: 0,
    MAX: 10000,
    MAX_EXCLUSIVE: 10000, // 경고 메시지용
  },
};

// 날짜 포맷
export const DATE_FORMAT = "yyyy-MM-dd";

// 기본값
export const DEFAULT_VALUES = {
  EMPTY_STRING: "",
  ZERO: "0",
};

// 에러 메시지 상수
export const ERROR_MESSAGES = {
  // 로그인 관련
  NO_PROGRAM_PERMISSION: "프로그램 권한이 존재하지 않습니다.",
  LOGIN_ERROR: "로그인 중 오류가 발생했습니다.",
  SSO_LOGIN_ERROR: "SSO 로그인 중 오류가 발생했습니다.",
  
  // 엑셀 관련
  EXCEL_EXPORT_ERROR: "엑셀 내보내기 중 오류가 발생했습니다.",
  
  // 날짜 검증 관련
  DATE_REQUIRED: "날짜는 반드시 입력해야 합니다.",
  START_DATE_REQUIRED: "시작 날짜는 반드시 입력해야 합니다.",
  END_DATE_REQUIRED: "종료 날짜는 반드시 입력해야 합니다.",
  START_DATE_BEFORE_END: "시작 날짜는 종료 날짜보다 이전이어야 합니다.",
  
  // 숫자 범위 검증 관련
  getThicknessMaxExclusiveMessage: (max) => `두께는 ${max} 보다 작은 숫자를 입력하세요`,
  getWidthMaxExclusiveMessage: (max) => `폭은 ${max.toLocaleString()} 보다 작은 숫자를 입력하세요`,
};
